<template>
  <BaseEditModal
    :displayName="title"
    :icon="icon"
    hideBottomButtons
    :hideTabs="true"
    :tabs="tabs"
    :customState="formState"
    @close="handleCancel">
    <template #prepend-buttons>
      <v-btn
        variant="flat"
        @click="handleCancel">
        Cancel
      </v-btn>
    </template>
    <template #append-buttons>
      <v-btn
        color="primary"
        variant="flat"
        :loading="props.loading"
        :disabled="!canSubmit"
        @click="handleSubmit">
        <v-icon class="mr-2">{{ confirmIcon }}</v-icon>
        {{ confirmLabel }}
      </v-btn>
    </template>
  </BaseEditModal>
</template>
<script setup>
import { computed, reactive, watch } from 'vue';
import BaseEditModal from '../Shared/Modals/BaseEditModal.vue';
import CreateAssetGroupForm from './CreateAssetGroupForm.vue';

const props = defineProps({
  open: { type: Boolean, default: false },
  title: { type: String, default: 'Create Asset Group' },
  subtitle: { type: String, default: 'Name your new group' },
  icon: { type: String, default: 'mdi-folder-multiple-plus' },
  confirmLabel: { type: String, default: 'Create' },
  confirmIcon: { type: String, default: 'mdi-check-circle' },
  loading: { type: Boolean, default: false },
  initialName: { type: String, default: '' },
  initialDescription: { type: String, default: '' },
  showDescription: { type: Boolean, default: true },
  contextMessage: { type: String, default: '' },
});

const emit = defineEmits(['close', 'submit']);

const formState = reactive({
  name: props.initialName || '',
  description: props.initialDescription || '',
});

const tabs = computed(() => [
  {
    id: 0,
    title: props.subtitle || 'Details',
    icon: 'mdi-text-box-edit',
    display: true,
    component: CreateAssetGroupForm,
    props: {
      showDescription: props.showDescription,
      contextMessage: props.contextMessage,
    },
    emits: {
      'submit-intent': handleSubmit,
    },
  },
]);

const canSubmit = computed(
  () => formState.name.trim().length > 0 && !props.loading
);

watch(
  () => props.initialName,
  (value) => {
    formState.name = value || '';
  }
);

watch(
  () => props.initialDescription,
  (value) => {
    formState.description = value || '';
  }
);

watch(
  () => props.open,
  (value) => {
    if (value) {
      resetForm();
    }
  }
);

function resetForm() {
  formState.name = props.initialName || '';
  formState.description = props.initialDescription || '';
}

function handleSubmit() {
  if (!canSubmit.value) {
    return;
  }
  emit('submit', {
    name: formState.name.trim(),
    description: formState.description?.trim() || '',
  });
}

function handleCancel() {
  emit('close');
}
</script>
<style scoped>
:deep(.dialog-card) {
  max-width: 420px;
}
</style>
